import { 
  STOCK_DICTIONARY_EDIT_TRANSLATION_PENDING,
  STOCK_DICTIONARY_EDIT_TRANSLATION_SUCCESS,
  STOCK_DICTIONARY_EDIT_TRANSLATION_FAILURE,
  STOCK_DICTIONARY_EDIT_TRANSLATION_DISMISS_ERROR,
} from '../constants'


export function reducer(state, action){
  switch (action.type){
    case STOCK_DICTIONARY_EDIT_TRANSLATION_PENDING:
      return {
        ...state,
        editDictionaryTranslationPending: true,
        editDictionaryTranslationSuccess: false,
        editDictionaryTranslationError: null,
      }
    case STOCK_DICTIONARY_EDIT_TRANSLATION_SUCCESS:
      return {
        ...state,
        editDictionaryTranslationPending: false,
        editDictionaryTranslationSuccess: true,
      }
    case STOCK_DICTIONARY_EDIT_TRANSLATION_FAILURE:
      return {
        ...state,
        editDictionaryTranslationPending: false,
        editDictionaryTranslationError: action.data.error,
      }
    case STOCK_DICTIONARY_EDIT_TRANSLATION_DISMISS_ERROR:
      return {
        ...state,
        editDictionaryTranslationPending: false,
        editDictionaryTranslationError: null,
      }
    default: return state
  }
}